async function post_data(url, data = {}) {
  const response = await fetch(url, {
    method: "POST",
    body: data,
  });
  return response.json();
}

function debounce(func, timeout = 200) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}


function set_layout_icon(local_storage_key) {
  const projects_display_icon_container = document.querySelector(
    ".navigation__top-layout"
  );
  projects_display_icon_container.innerHTML =
    localStorage.getItem(local_storage_key) !== "list"
      ? '<i class="fas fa-list navigation__top-layout-icon"></i>'
      : '<i class="fas fa-th-large navigation__top-layout-icon"></i>';
  return true;
}

function change_layout_style(list_to_display, local_storage_key) {
  const projects_display_icon_container = document.querySelector(
    ".navigation__top-layout"
  );
  projects_display_icon_container.addEventListener("click", () => {
    // get local storage project_display_style
    let project_display_style = localStorage.getItem(local_storage_key);
    // set local storage project_display_style
    localStorage.setItem(
      local_storage_key,
      project_display_style === "list" ? "grid" : "list"
    );
    set_layout_icon(local_storage_key);
    list_to_display.display_data();
  });
}

function search(event, function_name, list_to_display, pagination) {
  const search = event.target.value;
  const form = new FormData();
  form.append(
    "data",
    JSON.stringify({ function: function_name, search: search, collection: collection.value, getCount: true })
  );
  post_data("./includes/ajax.inc.php", form).then((response) => {
    if (!response) response = [];
    const count = response.pop() ?? 0;
    list_to_display.data = response;
    list_to_display.display_data();
    if (pagination === false) return;
    pagination.total_pages = Math.ceil(count / pagination.items_per_page);
    pagination.current_page = 1;
    pagination.display_pagination();
  });
}

function copy_input_text_to_clipboard(copyText) {
  copyText.select();
  copyText.setSelectionRange(0, 99999); /* For mobile devices */

  /* Copy the text inside the text field */
  navigator.clipboard.writeText(copyText.value);
}

function get_number_of_rows(response) {
  let count = 0;
  for (const row of response) {
    if ("count" in row) {
      count = row.count;
    }
  }
  return count;
}

async function getProjectId() {
  const url = new URL(window.location.href);
  const project_id = url.searchParams.get("project");
  return project_id;
}

function getProjectVersion() {
  const url = new URL(window.location.href);
  const version = url.searchParams.get("version");
  return version;
}

function getElementPosition(el) {
  let _x = 0;
  let _y = 0;
  const rect = el.getBoundingClientRect();
  _x = el.offsetWidth + 10 + rect.left + window.scrollX;
  _y = el.offsetHeight / 2 + rect.top + window.scrollY;
  return {
    left: _x,
    top: _y,
  };
}

function transferValuesToCopyForm(e) {
  if (
    e.target.type !== "text" &&
    e.target.type !== "number" &&
    e.target.tagName.toLowerCase() !== "textarea"
  )
    return;
  const elementId = e.target.id;  
  const copiedElement = document.querySelector("#copy-" + elementId);
  if (!copiedElement) return;
  else copiedElement.value = e.target.value;
}

function transferValuesToCopyFormForCheckboxAndSelectFields(e) {
  if (e.target.type === "checkbox") {
    const elementId = e.target.id;
    const copiedElement = document.getElementById("copy-" + elementId);
    if (!copiedElement) return;
    copiedElement.checked = !copiedElement.checked;
    radioButtonCheck(e.target);
  }
}

function isCheckboxSpan(e) {
  return (
    e.target.tagName === "SPAN" &&
    e.target.parentElement.classList.contains("editor-form__checkbox")
  );
}

function toggleChecboxCheck(checkboxSpanElement) {
  const checkbox = checkboxSpanElement.parentElement.querySelector("input[type='checkbox']");
  checkbox.checked = !checkbox.checked;

  // Special handling for L-R and no-L-R checkboxes
  if (checkbox.id === 'L-R') {
    document.querySelector('#copy-L-R').checked = checkbox.checked;
    if (checkbox.checked) {
      document.querySelector('#no-L-R').checked = false;
    }
  } else if (checkbox.id === 'no-L-R') {
    if (checkbox.checked) {
      document.querySelector('#L-R').checked = false;
      document.querySelector('#copy-L-R').checked = false;
    }
  } else {
    // General case for other checkboxes
    document.querySelector('#copy-' + checkbox.id).checked = checkbox.checked;
  }

  radioButtonCheck(checkbox);
}


function radioButtonCheck(checkbox) {
  if (!checkbox.checked) return;
  const radioButtons = [ 
    ['boring', 'no-boring'], 
    ['L-R', 'no-L-R', 'pair'], 
    ['borders', 'allover', 'motif', 'gallon', 'band', 'e-2']
  ];

  for (const radiosButtonArray of radioButtons) {
    if (!radiosButtonArray.includes(checkbox.name)) continue;

    if (
      radiosButtonArray.includes('L-R') &&
      radiosButtonArray.includes('no-L-R') &&
      radiosButtonArray.includes('pair')
    ) {
      if (checkbox.name === 'L-R') {
        document.querySelector('#no-L-R').checked = false;
        document.querySelector('#pair').checked = false;
        document.querySelector('#copy-L-R').checked = true;
      } else if (checkbox.name === 'no-L-R') {
        document.querySelector('#L-R').checked = false;
        document.querySelector('#pair').checked = false;
        document.querySelector('#copy-L-R').checked = false;
      } else if (checkbox.name === 'pair') {
        document.querySelector('#L-R').checked = false;
        document.querySelector('#no-L-R').checked = false;
        document.querySelector('#copy-L-R').checked = false;
      }
      continue;
    }
    

    for (const item of radiosButtonArray) {
      if (item !== checkbox.name) {
        document.querySelector('#' + item).checked = false;
        const copyCheckbox = document.querySelector('#copy-' + item);
        if (copyCheckbox) {
          copyCheckbox.checked = false;
        }
      }
    }
  }
}


function setContainerBackgroundColor(e) {
  e.target.parentElement.style.backgroundColor = e.target.value;
  if (e.target.id.includes('sequins')) return;
  document.querySelector('#copy-' + e.target.id)?.parentElement.style.backgroundColor = e.target.value;
}


// Function which will upload all attachments (main image, additional image, additional documents)
async function getUploadedFilesFormData(folderName) {

  const mainImage = document.getElementById("fileInput");
  const fileInputs = document.getElementById("fileInputForm");
  const additionalImage = document.getElementById("fileInputAddition");
  const formData = new FormData();

  formData.append("mainImage", mainImage.files[0]);

  if (additionalImage.files.length > 0) {
    formData.append("additionalImage", additionalImage.files[0]);
  }

  for (let i = 0; i < fileInputs.files.length; i++) {
    formData.append("files-" + i, fileInputs.files[i]);
  }

  folderName = folderName.includes("/") ? folderName.split("/")[0].split('folder-')[1] : folderName;
    
  formData.append("data", folderName);

  formData.append(
    "data",
    JSON.stringify({
      function: "save_project_folder",
      folder: folderName,
      count: fileInputs.files.length,
    })
  );

  return formData;

}

function showPreview(file) {
  if (file) {
    const reader = new FileReader();

    reader.onload = function (e) {
      const imagePreviewContainer = document.querySelector(
        ".image-preview-container"
      );
      imagePreviewContainer.style.display = "flex"; // Show the image element
      const imagePreview = document.querySelector(".image-preview");
      imagePreview.src = e.target.result;
    };

    reader.readAsDataURL(file); // Convert the file into Data URL for preview
    document.querySelector(
        ".upload-container-addition"
      ).classList.remove("d-none");
  }
}

function showAditionalFilePreview(file) {
  if (file) {
    const reader = new FileReader();

    reader.onload = function (e) {
      showAditionalImagePreview(e.target.result);
    };

    reader.readAsDataURL(file[0]); // Convert the file into Data URL for preview   
  }
}

function showAditionalImagePreview(file) {
  if (file) {
    const imagePreviewContainer = document.querySelector(
        ".upload-container-addition"
      );
      imagePreviewContainer.classList.remove("d-none");
      const imagePreview = imagePreviewContainer.querySelector("img");
      imagePreview.src = file;
      imagePreview.classList.remove("d-none");
      const label = imagePreviewContainer.querySelector(".text-label");

      if(label){
        label.textContent = "Change additional image";
        label.classList.remove("d-none");
        label.classList.add("label-button");
      }

      const uploadLabel = imagePreviewContainer.querySelector("#drop-area-addition");
      if(uploadLabel){
        uploadLabel.classList.add("d-none");
      }

      const removeButton = imagePreviewContainer.querySelector("#remove-additional-image");
      if(removeButton){
        removeButton.classList.remove("d-none");
      }

    }
  }

async function removeAditionalImagePreview() {
  const imagePreviewContainer = document.querySelector(
    ".upload-container-addition"
  );
  const imagePreview = imagePreviewContainer.querySelector("img");
  imagePreview.src = "";
  imagePreview.classList.add("d-none");
  const label = imagePreviewContainer.querySelector(".text-label");
  label.classList.add("d-none");
  const uploadLabel = imagePreviewContainer.querySelector("#drop-area-addition");
  uploadLabel.classList.remove("d-none");
  const removeButton = imagePreviewContainer.querySelector("#remove-additional-image");
  removeButton.classList.add("d-none");
  const projectVersion = getProjectVersion();
  const form = new FormData();
  form.append("data", JSON.stringify({ function: "remove_additional_image", project_id: await getProjectId(), version: projectVersion }));
  try {
    const response = await post_data("./includes/ajax.inc.php", form);
  } catch (error) {
    console.log(error);
  }
  // remove the additional image from input field
  const additionalImage = document.getElementById("fileInputAddition");
  additionalImage.value = "";
}


// Handle the uploaded files
function showCopyFormAndSketchPreview(files) {
  // show copy form on upload
  document.querySelector(".copy-form-container").classList.add("visible");
  showPreview(files[0]);
  moveUploadButtonForNewImage();
  createRuler();
}

function moveUploadButtonForNewImage() {
  const uploadLabel = document.getElementById('drop-area');
  if(uploadLabel){
    uploadLabel.textContent = 'Upload new file';
    uploadLabel.classList.add('label-button')
  }
}

const createNotification = () => {
  let notificationTimeout;
  let notificationQueue = [];
  let isDisplaying = false;

  const processQueue = () => {
    if (isDisplaying || notificationQueue.length === 0) return;

    isDisplaying = true;
    const { status, message, time } = notificationQueue.shift();

    const element = document.querySelector('.navigation-notification p');
    element.textContent = message;

    if (status === 'error') {
      element.classList.add('error');
    } else {
      element.classList.remove('error');
    }

    notificationTimeout = setTimeout(() => {
      element.textContent = '';
      element.classList.remove('error');
      isDisplaying = false;
      processQueue(); // Process the next notification in the queue
    }, time);
  };

  return (status, message, time = 2000) => {
    notificationQueue.push({ status, message, time });
    processQueue();
  };
};

const showNotification = createNotification();


function showErrorMessage(message) {
  const element = document.querySelector('.form-error');
  const textField = element.querySelector('.form-error__message');
  element.classList.add('show');
  textField.textContent = message;
}
function removeErrorMessage() {
  const element = document.querySelector('.form-error');
  element.classList.remove('show');
}

function createRuler() {
  const element = document.querySelector('.editor-content__image');
  const dimensions = getElementDimensionsInCM(element);
  const spanNumbersHorizontal = Math.floor( (dimensions.width - 1) / 0.1 );
  const spanNumbersVertical = Math.floor( (dimensions.height - 1) / 0.1 );
  const bottomContainer = document.createElement('div');
  bottomContainer.classList.add('ruler-bottom-container');

  for (let i = 0; i < spanNumbersHorizontal; i ++) {
    const span = document.createElement('span');
    span.classList.add('ruler-bottom-span');
    const position =  i * 0.1;
    span.style.left = position + 'cm';
    bottomContainer.appendChild(span)
    if (i % 10 === 0) {
      const number = i / 10;
      span.innerHTML = '<span class="ruler-number-bottom"> ' + number + ' </span>';
    }
    if (i % 5 === 0) {
      span.classList.add('taller')
    }
  }
  element.appendChild(bottomContainer)

  const topContainer = document.createElement('div');
  topContainer.classList.add('ruler-top-container')
  for (let i = 0; i < spanNumbersVertical; i ++) {
    const span = document.createElement('span');
    span.classList.add('ruler-top-span');
    const position =  i * 0.1;
    span.style.bottom = position + 'cm';
    topContainer.appendChild(span)
    if (i % 10 === 0) {
      const number = i / 10;
      span.innerHTML = '<span class="ruler-number-top"> ' + number + ' </span>';
    }
    if (i % 5 === 0) {
      span.classList.add('taller')
    }
  }
  element.appendChild(topContainer)
  showRulerBackground();
}

function showRulerBackground() {
  document.querySelector('.ruler-background-top').classList.add('show');
  document.querySelector('.ruler-background-bottom').classList.add('show');
}

function getElementDimensionsInCM(element) {
    // Get computed style for the element
    const style = window.getComputedStyle(element);

    // Parse the width and height values (removing "px")
    const widthInPixels = parseFloat(style.width);
    const heightInPixels = parseFloat(style.height);

    // Convert pixels to centimeters
    const pixelsPerCM = 96 / 2.54; // 96 pixels is roughly 1 inch which is 2.54 cm
    const widthInCM = widthInPixels / pixelsPerCM;
    const heightInCM = heightInPixels / pixelsPerCM;

    return {
        width: widthInCM,
        height: heightInCM
    };
}



function showUploadedFileNames(files) {

  const documents = document.querySelector(".editor-form__documents");
  let docFileId = 0;
  const existingFileNames = new Set();
  const duplicateFiles = [];

  // Collect existing file names to avoid duplicates
  documents.querySelectorAll(".editor-form__document span").forEach((doc) => {
    existingFileNames.add(doc.textContent.trim());
  });

  for (const file of files) {
    if (!existingFileNames.has(file.name)) {
      documents.innerHTML +=
        "<li class='editor-form__document'><span> " +
        file.name +
        "</span> <i class='fas fa-trash form-editor__icon remove-file' data-remove='file' data-id='" +
        docFileId +
        "'> </i> </li>";
      existingFileNames.add(file.name); // Add the new file to the set
    } else {
      duplicateFiles.push(file.name); // Collect the duplicate file name
    }
    docFileId++;
  }

  return duplicateFiles; // Return the list of duplicate file names

}



function updateUplaodedFiles(element) {
  
  const input = document.querySelector("#fileInputForm");
  element.parentElement.remove();
  
  if (input.files.length === 0 ) return;
  const filesArray = Array.from(input.files);
  // Remove the first file
  filesArray.splice(element.getAttribute("data-id"), 1);

  // Create a new FileList object
  const newFileList = new DataTransfer();

  filesArray.forEach((file) => {
    newFileList.items.add(file);
  });
  // Set the new FileList
  input.files = newFileList.files;

}

export {
  post_data,
  debounce,
  set_layout_icon,
  search,
  change_layout_style,
  copy_input_text_to_clipboard,
  get_number_of_rows,
  getProjectId,
  getProjectVersion,
  getElementPosition,
  transferValuesToCopyForm,
  transferValuesToCopyFormForCheckboxAndSelectFields,
  isCheckboxSpan,
  toggleChecboxCheck,
  setContainerBackgroundColor,
  getUploadedFilesFormData,
  showCopyFormAndSketchPreview,
  showUploadedFileNames,
  updateUplaodedFiles,
  moveUploadButtonForNewImage,
  createRuler,
  showNotification,
  showErrorMessage,
  removeErrorMessage,
  showAditionalFilePreview,
  showAditionalImagePreview,
  removeAditionalImagePreview
};
